export default __webpack_public_path__ + "static/media/hamburger.13e1af2d.svg";